import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { localeDirection } from './i18n.ts';

export const applyDocumentLocale = (locale: string): 'ltr' | 'rtl' => {
  const direction = localeDirection(locale);
  document.documentElement.lang = locale;
  document.documentElement.dir = direction;
  return direction;
};

export const useDirection = (): 'ltr' | 'rtl' => {
  const { i18n } = useTranslation();
  const direction = localeDirection(i18n.language);
  useEffect(() => {
    applyDocumentLocale(i18n.language);
  }, [i18n.language]);
  return direction;
};
